import {
  LiveChatInvitation,
  LiveChatInvitationNotificationDetails,
  LiveChatInvitationStatus,
} from "@scrile/api-provider/dist/api/LiveChatInvitationsProvider";
import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { liveNames } from "@/lib/liveHelpers";
import { NotificationData } from "@/types";
import { EVENTS } from "@/const";

export default function(notification: Notification<LiveChatInvitationNotificationDetails>): NotificationData | false {
  const user = notification.user;
  if (notification.type === NotificationType.LIVECHAT_INVITATION && user) {
    if (notification.details.invitation.status === LiveChatInvitationStatus.NEW) {
      return {
        text: $t("{0} invites you to {1}", [
          user.screenName,
          liveNames[notification.details.invitation.subject.subjectType],
        ]),
        position: "top",
        timeout: 60000,
        image: {
          user: user,
        },
        onNotificationClick: () =>
          emitter.emit(EVENTS.MODAL_CONTROLLER_SHOW, {
            component: "ConfirmLiveChatInvitation",
            props: {
              invitation: notification.details.invitation,
            },
          }),
      };
    } else {
      emitter.emit<LiveChatInvitation>(EVENTS.LIVE_INVITATION_UPDATED, notification.details.invitation);
    }
  }
  return false;
}
